export type NavLink = { slug: string; label: string };
export const navLinks: NavLink[] = [
  { slug: "/", label: "Dashboard" },
  { slug: "/purchases", label: "Purchases" },
  { slug: "/listings", label: "Listings" },
  { slug: "/items", label: "Items" },
];
